import { render } from "./MyWizard.vue?vue&type=template&id=45227a87"
import script from "./MyWizard.vue?vue&type=script&lang=js"
export * from "./MyWizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__